import React from 'react';
import { classNames } from 'helpers/style/classNames';
import useStyle from './containerHalf.style';

export interface ContainerHalfProps {
  col1?: React.ReactNode;
  col2?: React.ReactNode;
  variant?: 'default' | 'dashboard';
}

export const ContainerHalf = ({
  col1,
  col2,
  variant = 'default'
}: ContainerHalfProps) => {
  const classes = useStyle();

  return (
    <div className={classNames([classes.root, classes[variant]])}>
      <div
        className={classNames(
          [],
          [
            { condition: variant === 'default', classe: classes.col },
            { condition: variant === 'dashboard', classe: classes.coldashboard }
          ]
        )}
      >
        {col1}
      </div>
      <div
        className={classNames(
          [],
          [
            { condition: variant === 'default', classe: classes.col },
            { condition: variant === 'dashboard', classe: classes.coldashboard }
          ]
        )}
      >
        {col2}
      </div>
    </div>
  );
};
